import { sprintf } from 'sprintf-js';
import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

const URLS = {
  GET_PRODUCTS: '/org/%s/admin/products/',
  GET_PRODUCT: '/org/%s/admin/products/%s/',
};

export const organizationProduct = {
  getProducts: ({
    organizationCodename,
    params,
  }: {
    organizationCodename: string;
    params?: SearchParamsType;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.GET_PRODUCTS, organizationCodename),
      params: {
        ...params,
      },
    }),

  getProduct: ({
    organizationCodename,
    id,
  }: {
    organizationCodename: string;
    id: string;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.GET_PRODUCT, organizationCodename, id),
    }),
  updateProduct: ({
    organizationCodename,
    id,
    data,
  }: {
    organizationCodename: string;
    id: number;
    data: any;
  }) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.GET_PRODUCT, organizationCodename, id),
      data,
    }),
};
